<!--
 * @Author: gongzhichao
 * @Date: 2023-05-09 17:56:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 面包屑导航组件
-->
<template>
  <div class="breadcrumb">
    <div class="title">
      {{ $route.query.path ? $route.query.path : $route.query.title }}
    </div>
    <div class="nav">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-location-outline"></i>
          官网首页
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path, query: { title: $route.query.path } }"
          v-if="$route.query.path"
          >{{ $route.query.path }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $route.query.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    path() {
      return this.$route.query.path == "江湖资料"
        ? "/information"
        : "/newspaper";
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 70px;
  padding-bottom: 10px;
  .title {
    width: 150px;
    text-align: center;
    border-left: 5px solid #866e4f;
    font-size: 25px;
    color: #000;
  }
  .nav {
    .bread-crumbs-item {
      text-decoration: none;
      color: #000;
    }
    /deep/ .el-breadcrumb__inner.is-link,
    .el-breadcrumb__inner a {
      font-weight: normal;
    }
    i {
      margin: 0 10px;
    }
  }
}
</style>
